import { t } from 'ember-intl'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import Component from '@glimmer/component'
import { subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import ThemedModal, { ModalBody, ModalHeader } from 'teacher-ui-client/components/base/themed-modal'
import FidgetSpinnerWaveComponent from '@blakeelearning/fidget/components/fidget/spinner/wave'

interface Signature {
  Element: HTMLElement
  Args: {
    showModal: boolean
    fromSubscriptionType: SubscriptionType
    toSubscriptionType: SubscriptionType
    classCount: number
    onCancel: () => void
  }
}

export class ProgressModal extends Component<Signature> {
  get themeKey() {
    return subscriptionTypeToThemeKey(this.args.toSubscriptionType)
  }

  <template>
    <ThemedModal @show={{@showModal}} @close={{@onCancel}}>
      <ModalHeader @themeKey={{this.themeKey}}>
        <FidgetSpinnerWaveComponent @small={{true}} />
        <h3 class="ml-3">
          {{t "components.copyClasses.progressDialog.heading"}}</h3>
      </ModalHeader>
      <ModalBody>
        {{t
          "components.copyClasses.progressDialog.summary"
          htmlSafe=true
          count=@classCount
          fromSubscriptionType=(t @fromSubscriptionType)
          toSubscriptionType=(t @toSubscriptionType)
        }}
      </ModalBody>
    </ThemedModal>
  </template>
}
